<template>
	<div id="main" class="lg:w-1/2 h-full overflow-y-scroll">
		<div
			class="px-5 py-4 border-b border-lighter flex items-center justify-between"
		>
			<h1 class="text-xl font-bold">Home</h1>
			<i class="fas fa-star text-blue text-xl"></i>
		</div>
		<div class="px-5 py-3 border-b-8 border-lighter flex">
			<div class="flex-none">
				<img
					src="../assets/images/kajalshanto.jpg"
					class="flex-none w-12 h-12 rounded-full border border-lighter"
				/>
			</div>
			<form
				v-on:submit.prevent="addNewTweet()"
				class="w-full px-4 relative"
			>
				<textarea
					v-model="tweet.content"
					placeholder="What's up?"
					class="mt-3 pb-3 w-full focus:outline-none"
				/>
				<div class="flex items-center">
					<i
						class="text-lg text-blue mr-4 far fa-image cursor-pointer"
					></i>
					<i
						class="text-lg text-blue mr-4 fas fa-film cursor-pointer"
					></i>
					<i
						class="text-lg text-blue mr-4 fas fa-chart-bar cursor-pointer"
					></i>
					<i
						class="text-lg text-blue mr-4 far fa-smile cursor-pointer"
					></i>
				</div>
				<button
					type="submit"
					class="h-10 px-4 text-white font-semibold bg-blue hover:bg-darkblue focus:outline-none rounded-full absolute bottom-0 right-0"
				>
					Tweet
				</button>
			</form>
		</div>
		<div class="flex flex-col-reverse">
			<div
				v-for="(tweet, index) in tweets"
				:key="index"
				class="w-full p-4 border-b hover:bg-lighter flex"
			>
				<div class="flex-none mr-4">
					<img
						src="../assets/images/kajalshanto.jpg"
						class="h-12 w-12 rounded-full flex-none"
					/>
				</div>
				<div class="w-full">
					<div class="flex items-center w-full">
						<p class="font-semibold">Hasibul Hasan</p>
						<p class="text-sm text-dark ml-2">@hasibulhasan</p>
						<p class="text-sm text-dark ml-2">1 sec</p>
						<i class="fas fa-angle-down text-dark ml-auto"></i>
					</div>
					<p class="py-2">
						{{ tweet.content }}
					</p>
					<div class="flex items-center justify-between w-full">
						<div class="flex items-center text-sm text-dark">
							<i class="far fa-comment mr-3"></i>
							<p>0</p>
						</div>
						<div class="flex items-center text-sm text-dark">
							<i class="fas fa-retweet mr-3"></i>
							<p>0</p>
						</div>
						<div class="flex items-center text-sm text-dark">
							<i class="fas fa-heart mr-3 text-blue"></i>
							<p>0</p>
						</div>
						<div class="flex items-center text-sm text-dark">
							<i class="fas fa-share-square mr-3"></i>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div
			v-for="(follow, index) in following"
			:key="index"
			class="w-full p-4 border-b bg-lightest hover:bg-lighter flex"
		>
			<div class="flex-none mr-4">
				<img
					:src="require(`@/assets/images/${follow.src}`)"
					class="h-12 w-12 rounded-full flex-none"
				/>
			</div>
			<div class="w-full">
				<div class="flex items-center w-full">
					<p class="font-semibold">{{ follow.name }}</p>
					<p class="text-sm text-dark ml-2">{{ follow.handle }}</p>
					<p class="text-sm text-dark ml-2">{{ follow.time }}</p>
					<i class="fas fa-angle-down text-dark ml-auto"></i>
				</div>
				<p class="py-2">
					{{ follow.tweet }}
				</p>
				<div class="flex items-center justify-between w-full">
					<div class="flex items-center text-sm text-dark">
						<i class="far fa-comment mr-3"></i>
						<p>{{ follow.comments }}</p>
					</div>
					<div class="flex items-center text-sm text-dark">
						<i class="fas fa-retweet mr-3"></i>
						<p>{{ follow.retweets }}</p>
					</div>
					<div class="flex items-center text-sm text-dark">
						<i class="fas fa-heart mr-3 text-blue"></i>
						<p>{{ follow.like }}</p>
					</div>
					<div class="flex items-center text-sm text-dark">
						<i class="fas fa-share-square mr-3 cursor-pointer"></i>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "Main",

		data() {
			return {
				following: [
					{
						src: "elon.jpg",
						name: "Elon Mask",
						handle: "@teslaBoy",
						time: "20 min",
						tweet: "New possibities to live in space. Stay with spaceX",
						comments: "1,000",
						retweets: "550",
						like: "1,00,003",
					},
					{
						src: "ranbeer.jpg",
						name: "Ranbeer Kapoor",
						handle: "@ranbeerPboy",
						time: "55 min",
						tweet: "Hello everyone. Now i'm working on a new movie. Trailer will coming at the end of this month. Stay tuned eith my tweets!",
						comments: "5,020",
						retweets: "110",
						like: "1,00,0523",
					},
					{
						src: "sakib.jpg",
						name: "Sakib Al Hasan",
						handle: "@sakibTiger",
						time: "1.4 hr",
						tweet: "I will go Bali, Indonesia this month ??",
						comments: "738",
						retweets: "230",
						like: "10,503",
                    },
                    
					{
						src: "jolil.jpg",
						name: "Ananta Jalil",
						handle: "@anantaJalil",
						time: "24 hr",
						tweet: "Osomvab ke samvov korai amar kaj. Just call me. I will make all kinds of work possible. That is the promise from Barsha :) ",
						comments: "1722",
						retweets: "30",
						like: "10,285",
                    },
                    {
						src: "ranbeer.jpg",
						name: "Ranbeer Kapoor",
						handle: "@ranbeerPboy",
						time: "1 day",
						tweet: "Girls im now in Goa beach. Come on lets's have some fun. I'll hire a ship to spend with you all night in the sea. Come soon before i'll sail........!!!",
						comments: "5,020",
						retweets: "110",
						like: "1,00,0523",
                    },
                    {
						src: "sakib.jpg",
						name: "Sakib Al Hasan",
						handle: "@sakibTiger",
						time: "1 day",
						tweet: "Now enjoyin my holidays in England. Stay safe and stay home during this pandemic.",
						comments: "738",
						retweets: "230",
						like: "10,00,503",
                    },
				],

				tweets: [{ content: "Vue js is awesome! and Tailwind makes it super fun and enjoyable to work togeter :)" }],
				tweet: { contenet: " " },
			};
		},
		methods: {
			addNewTweet() {
				let newTweet = {
					content: this.tweet.content,
				};
                this.tweets.push(newTweet);
                this.tweet.content = ' ';
			},
		},
	};
</script>
